module.exports = __webpack_public_path__ + "static/img/Jared-Polec.51c9bb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jared-Polec.jpg
// module id = OvzQ
// module chunks = 0